import { Message } from 'element-ui'

const showMessage = Symbol('showMessage');
class DonMessage {
    success(options, single = true) {
        this[showMessage]('success', options, single)
    }
    warning(options, single = true) {
        this[showMessage]('warning', options, single)
    }
    info(options, single = true) {
        this[showMessage]('info', options, single)
    }
    error(options, single = true) {
        this[showMessage]('error', options, single)
    }

    [showMessage](type, options, single) {
        if (single) {
            // 判断是否已存在Message
            let doms = document.getElementsByClassName('el-message');
            // let canShow = true;
            // for (let i = 0; i < doms.length; i++) {
            //     if (options.message == doms[i].getElementsByClassName('el-message__content')[0].innerHTML) {
            //         canShow = false;
            //     }
            // }

            if (doms.length === 0) {
                Message[type](options);
            }
        } else {
            Message[type](options)
        }
    }
}
export default new DonMessage();





// WEBPACK FOOTER //
// ./src/utils/resetMessage.js